import macpracticeIcon from "../assets/media/macpractice-icon.jpg";
import isoftIcon from "../assets/media/isoft-icon.jpg";
import teamSoftwareIcon from "../assets/media/teamsoftware-icon.jpg";
import nordstromIcon from "../assets/media/nordstrom-icon.jpg";
import classmatesIcon from "../assets/media/classmates-icon.jpg";

export interface Role {
  id: number;
  title: string;
  date: string;
  description?: string[];
}

export interface Jobs {
  id: number;
  company: string;
  office: "Onsite" | "Remote" | "Hybrid";
  location: string;
  icon: string;
  roles: Role[];
}

export const jobs: Jobs[] = [
  {
    id: 0,
    company: "MacPractice",
    office: "Onsite",
    location: "Lincoln, NE",
    icon: macpracticeIcon,
    roles: [
      {
        title: "Software Engineer",
        date: "Oct 2019 - Oct 2020",
        description: [],
        id: 1
      },
      {
        title: "SWE Intern",
        date: "Apr 2019 - Oct 2019",
        description: [],
        id: 0
      },
    ],
  },
  {
    id: 1,
    company: "ISoft Data Systems",
    office: "Onsite",
    location: "Lincoln, NE",
    icon: isoftIcon,
    roles: [
      {
        title: "Software Developer",
        date: "Nov 2020 - Jul 2021",
        description: [],
        id: 0
      },
    ],
  },
  {
    id: 2,
    company: "TEAM Software",
    office: "Remote",
    location: "Colorado Springs, CO",
    icon: teamSoftwareIcon,
    roles: [
      {
        title: "Software Developer",
        date: "Jul 2021 - Jan 2022",
        description: [],
        id: 0
      },
    ],
  },
  {
    id: 3,
    company: "Nordstrom",
    office: "Hybrid",
    location: "Seattle, WA",
    icon: nordstromIcon,
    roles: [
      {
        title: "Software Engineer 2 - Credit",
        date: "Jun 2023 - Oct 2024",
        description: [
          "Resolved a legacy bug blocking 30% of in-store transactions, resulting in ~$300K of OpEx savings",
          "Owned and maintained legacy applications for a POS system supporting thousands of daily transactions",
          "Led a full-scale rewrite for a new POS platform as one of the first teams to migrate, establishing best practices for subsequent teams",
          "Developed a typed component wrapper library empowering engineers to iterate quicker with reduced errors and improved testability",
          "Paired with frontend and backend engineers to resolve production issues and develop new features",
          "Collaborated with Product and UX partners to translate requirements into tasks and address engineering implementation concerns",
          "Partnered with QA on testing, piloting, and deployment plans to ensure seamless handoffs and operational success",
          "Created technical assessment material for interviewing, mentored teammates, and onboarded two new hires",
          "Authored onboarding documentation and contributed to company-wide engineering standards documentation",
        ],
        id: 2
      },
      {
        title: "Software Engineer 2 - Platform",
        date: "Aug 2022 - May 2023",
        description: [
          "Migrated 15K+ MRs and three years of engineering history to a new GitLab instance",
          "Owned and maintained the merge control system for a team of 70+ engineers",
          "Delivered technical presentations on CI/CD functionality and advancements to the engineering team",
        ],
        id: 1
      },
      {
        title: "Software Engineer 2 - SBN",
        date: "Jan 2022 - Aug 2022",
        description: [
          "Developed a new Search & Shop experience, driving a $2M increase in demand at 66% traffic and $212M at full traffic",
          "Increased filter engagement by up to 5.27% and reduced filter deselect rates by up to 57.93%",
          "Participated in bi-weekly product demos",
          "Researched and proposed strategies for migrating the codebase from UIKit to SwiftUI",
          "Paired with teammates to debug complex UI bugs and build feature improvements",
        ],
        id: 0
      },
    ],
  },
  {
    id: 4,
    company: "Classmates",
    office: "Hybrid",
    location: "Bellevue, WA",
    icon: classmatesIcon,
    roles: [
      {
        title: "Senior Software Engineer",
        date: "May 2025 - Present",
        description: [],
        id: 0
      },
    ],
  },
];
